import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateParser, TranslateService } from '@ngx-translate/core';
import { FilterOptions } from 'src/app/models/filterOptions';
import { RequestFilter } from 'src/app/models/requestfilter';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UrlService } from 'src/app/services/url.service';
import { LoggingService } from 'src/app/services/logging.service';
import { RequestItemInDashboard } from 'src/app/models/dashboard';
import { PlatformHubService } from 'src/app/services/platformhub.service';

@Component({
  selector: 'app-dashboardfilter',
  templateUrl: './dashboardfilter.component.html'
})
export class DashboardFilterComponent implements OnInit {
  @Input() requests: RequestItemInDashboard[] = [];
  @Input() selectedRequests!: RequestItemInDashboard[];
  @Output() filterChanged = new EventEmitter<RequestFilter>();
  @Output() actionSelected = new EventEmitter<string>();
  @Output() workgroup = new EventEmitter<boolean>();
  requestFilter: RequestFilter = <RequestFilter>{};
  event: any;
  optionStatusNew!: boolean;
  optionWorkgroup!: boolean;
  workgroups: any[] = [];
  dossierTypes: string[] = [];
  requestStatusses: string[] = [];
  filters: string[] = [];
  filteredItems: string = "";
  filterType: string | undefined;
  translations: any = <any>{};
  filterPlaceholder!: string;
  userGuid: string = '';
  myRequests: boolean = true;
  showAll: boolean = false;

  /**
   * Whether any Request have been 'Selected' for further actions
   */
  get hasSelectedRequest(): boolean {
    return (this.selectedRequests != undefined &&
      this.selectedRequests != null &&
      this.selectedRequests.length > 0);
  }

  constructor(private authenticationService: AuthenticationService, private translateService: TranslateService, private translateParser: TranslateParser, private router: Router, private urlService: UrlService, private loggingService: LoggingService, public platformHubService: PlatformHubService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
      this.setFilterBox();
    });
    this.authenticationService.currentUser.subscribe((data) => {
      this.userGuid = data.sub;
    });
    this.myRequests = new URL(window.location.href).searchParams.toString().indexOf("myrequests") == -1
  }

  getTranslations() {
    this.translateService.get([
      'RequestOperation.OneFilter',
      'RequestOperation.Filters',
      'RequestOperation.Filter.Hour'
    ]).subscribe(translation => {
      this.translations.RequestOperationOneFilter = translation['RequestOperation.OneFilter'];
      this.translations.RequestOperationFilters = translation['RequestOperation.Filters'];
      this.translations.RequestOperationFilterHour = translation['RequestOperation.Filter.Hour'];
    });
  }

  async ngOnInit(): Promise<void> {
    let inputType: FilterOptions[] = this.urlService.getSessionStorageFilterParams();

    this.setInputType([], inputType);
    this.setSearchValue(inputType);
    this.setFilterBox();
    let ShowAllDocsInOrg = sessionStorage.getItem("ShowAllDocsInOrg");
    if (ShowAllDocsInOrg != undefined && ShowAllDocsInOrg != null && ShowAllDocsInOrg != "false") {
      this.showAll = true;
    } else {
      this.showAll = false;
    }
    if (inputType.length > 0) {
      this.updateUrlParams(inputType);
      this.onFilterChanged();
    }
  }

  applyAction(action: string) {
    this.actionSelected.emit(action);
  }

  updateWorkgroupVisibility(action: boolean) {
    this.workgroup.emit(action);
  }
  onFilterChanged() {
    this.filterChanged.emit(this.requestFilter);
  }

  updateUrlParams(filters: FilterOptions[]) {
    filters.forEach((filter: FilterOptions) => {
      this.urlService.appendUrl(filter.type + ":" + filter.value);
    })
  }

  applyFilter(event: Event) {
    let filterValue: string = (event.target as HTMLInputElement).value;
    if ((event.target as HTMLInputElement).id === "inputSearch") {
      filterValue = "search:" + filterValue;
    };
    this.urlService.appendUrl(filterValue);
    this.setFilterBox();
    this.onFilterChanged();
  }

  FilterMyRequests(enableFilter: boolean) {
    let queryString = new URL(window.location.href).searchParams;
    let filterValue: string = "myrequests:" + this.userGuid
    // if enabling Filter and the url already contains the filter stop enabling filter
    if ((decodeURI(queryString.toString()).indexOf(filterValue.replace(":", "=").replaceAll(" ", "+")) > -1) != enableFilter) {
      return;
    }
    this.myRequests = enableFilter;
    this.updateWorkgroupVisibility(enableFilter)
    this.urlService.appendUrl(filterValue);
    this.setFilterBox();
    this.onFilterChanged();
  }


  removeUnnecessaryFilters(type: string, values: string[], params: FilterOptions[]) {
    params.forEach(p => {
      if (p.type.indexOf(type) > -1 && values.indexOf(p.value) === -1)
        this.urlService.appendUrl(p.type + ':' + p.value);
    });
  }

  checkRequestStatus() {
    let params: FilterOptions[] = this.urlService.getSessionStorageFilterParams();
    this.requestStatusses = this.requests.map(p => p.status);
    this.requestStatusses = this.requestStatusses.filter((item, i) => i === this.requestStatusses.indexOf(item) && item !== undefined);
    this.hideExpiredIfNotShowPurged();
    this.setInputType(this.requestStatusses, params);
    this.removeUnnecessaryFilters('status', this.requestStatusses, params);
    if (this.requestStatusses.length > 0) {
      return true;
    }
    return false;
  }

  checkDossierType() {
    let params: FilterOptions[] = this.urlService.getSessionStorageFilterParams();
    if (this.shouldShowPurgedRequests()) {
      this.dossierTypes = this.requests.map(p => p.dossierType);
    } else {
      this.dossierTypes = this.requests.filter(item => item.status.toLocaleLowerCase() !== 'expired').map(p => p.dossierType);
    }
    this.dossierTypes = this.dossierTypes.filter((item, i) => i === this.dossierTypes.indexOf(item));
    this.setInputType(this.dossierTypes, params);
    this.removeUnnecessaryFilters('type', this.dossierTypes, params);
    if (this.dossierTypes.length > 0) {
      return true;
    }
    return false;
  }

  checkTime(hour: number) {
    let params: FilterOptions[] = this.urlService.getSessionStorageFilterParams();
    this.setInputType([], params);

    let requestsExpiringWithinHours = this.requests.filter(request =>
      new Date(request.deadline!).getTime() < (new Date().getTime() + (1000 * 60 * 60 * hour)) &&
      new Date(request.deadline!).getTime() > (new Date().getTime())
    );
    if (requestsExpiringWithinHours.length > 0) {
      return true;
    }

    if (params.findIndex(p => p.type == 'expiresIn' && p.value == hour + '') > -1) {
      this.urlService.appendUrl('expiresIn:' + hour);
    }
    return false;
  }

  checkWorkgroups() {
    let params: FilterOptions[] = this.urlService.getSessionStorageFilterParams();
    this.workgroups = this.requests.map(p => p.workgroupName);
    this.workgroups = this.workgroups.filter(p => p !== null && p !== undefined && p !== '');
    this.workgroups = this.workgroups.filter((item, i) => i === this.workgroups.indexOf(item));
    this.workgroups = this.workgroups.filter((item) => this.authenticationService.workgroups.map(p => p.Name).includes(item));
    this.setInputType(this.workgroups, params);
    this.removeUnnecessaryFilters('workgroup', this.workgroups.filter((item: string | undefined): item is string => { return !!item }), params);

    if (this.workgroups.length > 0) {
      return true;
    }
    return false;
  }

  setFilterBox() {
    let params: FilterOptions[] = this.urlService.getSessionStorageFilterParams();
    if (params && params.length > 0) {
      this.filteredItems = ": ";
      if (params.length === 1) {
        this.filterPlaceholder = this.translations.RequestOperationOneFilter;
      } else {
        this.filterPlaceholder = this.translations.RequestOperationFilters;
      }
    } else {
      this.filteredItems = "";
      this.filterPlaceholder = this.translations.RequestOperationFilters;
    }
    params.forEach((param, index) => {
      if (param.type === "status" || param.type === "type") {
        this.translateService.get(["" + param.type.charAt(0).toUpperCase() + param.type.slice(1) + "." + param.value + ""]).subscribe(translation => {
          this.filterType = this.translateParser.interpolate(translation["" + param.type.charAt(0).toUpperCase() + param.type.slice(1) + "." + param.value + ""]);
        });
        this.filteredItems = this.filteredItems + this.filterType;
      } else if (param.type === "expiresIn") {
        this.filteredItems = this.filteredItems + param.value + " " + this.translations.RequestOperationFilterHour;
      } else if (param.type !== "search") {
        this.filteredItems = this.filteredItems + param.value;
      }
      if (index < params.length - 1) {
        this.filteredItems = this.filteredItems + "; ";
      }
    });
    if (document.getElementById("dropdownFilterMenu"))
      (document.getElementById("dropdownFilterMenu") as HTMLButtonElement).value = this.filteredItems;
  }

  setInputType(dossierItems: any[], params: FilterOptions[]) {
    params.forEach(param => {
      if (param.type !== "search" && dossierItems.length > 0 && document.getElementById(param.type + param.value) as HTMLInputElement !== null) {
        (document.getElementById(param.type + param.value) as HTMLInputElement).checked = true;
      }
    });
  }

  setSearchValue(params: FilterOptions[]) {
    let param = params.find(s => s.type === "search");
    if (param != null) (document.getElementById("input" + param.type.charAt(0).toUpperCase() + param.type.slice(1)) as HTMLInputElement).value = param.value;
  }

  /**
   * 
   * @returns bool with whether you are the owner of Any Selected Request (and thus cannot claim ownership over that Request)
   */
  IsOwnerOfAnySelectedRequest() {
    if (this.selectedRequests != undefined && this.selectedRequests != null && this.selectedRequests.length > 0 && this.selectedRequests.every(p => p.ownerGuid !== this.authenticationService.currentUserValue.sub)) {
      return false
    }
    return true;
  }

  openNewRequest() {
    this.router.navigate(["/build"])
      .catch(error => {
        this.loggingService.logException(error);
      });
  }

  hideExpiredIfNotShowPurged() {
    if (!this.shouldShowPurgedRequests()) {
      this.requestStatusses = this.requestStatusses.filter(item => item.toLocaleLowerCase() !== 'expired');
    }
  }

  shouldShowPurgedRequests() {
    let params: FilterOptions[] = []
    let search = new URLSearchParams(location.search);
    search.forEach(function (value, key) {
      params.push({
        type: key,
        value: value
      });

    });
    return (params.findIndex(s => s.type.toLowerCase() === "show") > -1);
  }
  userHasRequestsInWorkgroup() {
    return !this.platformHubService.requestSource.every(p => p.workgroupName == null || p.workgroupName == "");
  }
}
